import graphql from "babel-plugin-relay/macro";

const PartyDetailByIdQuery = graphql`
query PartyDetailByIdQuery($id:ID){
  allParties(id:$id){
    edges{
      node{
        id
        partyName
        partyImage
        politicianCount
        priceDiffPercentage
        mlaCount
        stocksOwned
        politicians{
          edges{
            node{
              id
              name
              politicianImage
              party{
                partyName
              }
              price 
           
              
            }
          }
        }
        president
        headquarters
        founded
        presidium
        lokSabhaMembers
        rajyaSabhaMembers
        similarParties{
          edges{
            node{
               id
               partyName
               partyImage 
               priceDiffPercentage 
            }
          }
        }
      }
    }
  }
}
`

export default PartyDetailByIdQuery;
// stockOwnedCount
// priceDiffPercentage